<template lang="pug">
v-dialog(scrollable max-width='460px' v-model='value' persistent lazy)
  v-card
    v-card-title(class='title')
      section
        div(class='title') Записать клиента
        div(class='subheading mt-2')
          | в {{ complex.complex_name }}
          | на {{ eventModel.start | date('DD MMM YYYY в HH:mm') }}
    v-card-text
      v-form(ref='form' :disabled='true')
        v-container(grid-list-lg fluid class='pa-0')
          v-layout(row wrap)
            v-flex(v-if='eventModel.busy >= eventModel.allow' xs12)
              v-alert(type='info' :value='true')
                span(class='subheading')
                  | Запись невозможна, все время занято
            v-flex(v-if='eventModel.busy < eventModel.allow' xs12)
              s-autocomplete(
                v-model='eventModel.client'
                label='Поиск клиента по ФИО или телефону'
                item-text='name'
                item-value='guid'
                data-source='manager/scheduleassign/clients'
                :rules='[v => v && !!Object.keys(v).length || "Выберите клиента"]'
                :params='{ schedule_id: eventModel.id }'
              )
            v-flex(v-if='eventModel.client.guid' xs12)
              v-select(
                :items='deals'
                :return-object='true'
                item-text='deal_name'
                item-value='id'
                label='Выберите договор'
                v-model='eventModel.deal'
                :rules='[v => v && !!Object.keys(v).length || "Выберите договор"]'
              )
                template(v-slot:item='{item}')
                    div(:class='{ "blocked": item.blocked==true }' v-html='item.deal_name')
                template(v-slot:selection='{item}')
                    div(:class='{ "blocked": item.blocked==true }' v-html='item.deal_name')
            //- Блок пока скрыт, до лучших времен как говорится
            //- v-flex(v-if='eventModel.deal.id' xs12)
            //-   v-layout(row wrap)
            //-     v-flex(xs12)
            //-       div(class='subheading grey--text text--darken-1')
            //-         | Отправить уведомление клиенту
            //-     v-flex(xs4)
            //-       v-checkbox(
            //-         v-model='eventModel.notify'
            //-         label='SMS'
            //-         color='primary'
            //-         class='mt-1'
            //-         value='sms'
            //-       )
            v-flex(v-if='eventModel.assigns && eventModel.assigns.length' xs12)
              assigns-list(
                @click='$emit("destroyAssign", $event)'
                :assigns='eventModel.assigns'
              )
    v-card-actions
      v-spacer
      v-btn(@click='$emit("input", false)' flat) Отмена
      v-btn(
        v-if='eventModel.busy < eventModel.allow'
        @click='emitChange'
        :loading='isLoading'
        color='primary'
        flat
      ) Ok
</template>

<script>
import http from '@/http'
import AssignsList from './AssignsList'

const eventModel = {
  client: {},
  notify: [],
  deal: {}
}

export default {
  props: ['value', 'event', 'isLoading', 'complex'],

  components: {
    AssignsList
  },

  data: () => ({
    deals: [],
    eventModel: { ...eventModel }
  }),

  methods: {
    emitChange() {
      if (this.$refs.form.validate()) {
        let { client, deal, id } = this.eventModel
        this.$emit('change', {
          schedule_id: id,
          client_guid: client.guid,
          deal_id: deal.id,
          is_share: deal.is_share
        })
      }
    },

    async fetchClientDeals(clientGuid) {
      try {
        this.deals = (
          await http.get('/manager/scheduleassign/deals', {
            params: {
              client_guid: clientGuid,
              schedule_id: this.event.id
            }
          })
        ).data
      } catch (e) {
        this.$root.showSnack('Ошибка загрузки списка договор клиента')
      }
    }
  },

  watch: {
    event(value) {
      if (Object.keys(value).length) {
        this.eventModel = Object.assign({}, value, eventModel)
      } else {
        this.eventModel = { ...eventModel }
      }
    },

    'eventModel.client'(client) {
      if (client.guid) {
        this.fetchClientDeals(client.guid)
      }
    },
    /**
     * Будем следить за состоянием видимости модального окна
     * и сбрасывать модель и валидацию, если окно закрыто
     * @param {boolean} visible
     */
    value(visible) {
      if (!visible) {
        this.$refs.form.reset()
        this.eventModel = { ...eventModel }
      }
    }
  }
}
</script>

<style>
.blocked {
  color: red;
}
/* Пока так – https://stackoverflow.com/questions/56665185/show-raw-html-in-vuetify-v-select */
/* в противном случае, показывается дополнитльеный input */
[aria-label='Выберите договор'] {
  display: none;
}
</style>
